import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { RootStoreState } from "../../../store/state";
import { selectSubscriptionRequest } from "../../../store/selectors";
import {
  SubscriptionTopics,
} from "../../../@api/client-api";
import { topicBooleanToStringMap } from "../../../helpers/topic-to-string-map";

@Component({
  selector: "newsletter-confirmation-page",
  templateUrl: "./confirmation-page.component.html",
  styleUrl: "./confirmation-page.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationPageComponent implements OnInit {
  public subscriptionData$ = this.store.select(selectSubscriptionRequest);
  public topicTitles: string[] = [];
  public contactEmail: string = "insight@spencerstuart.com";

  constructor(
    // eslint-disable-next-line @ngrx/no-typed-global-store
    private readonly store: Store<RootStoreState>
  ) {}
  ngOnInit(): void {
    this.subscriptionData$.subscribe((data) => {
      const topics: SubscriptionTopics = data.topics!;
      this.topicTitles = Object.keys(topics)
        .filter((key) => topics[key as keyof SubscriptionTopics] === true)
        .map((key) => topicBooleanToStringMap[key as keyof SubscriptionTopics]);
    });
  }
}
